import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App.tsx";
import { ApiError } from "./lib/api.ts";
// Self-hosted fonts (BLD-24): Inter for text, JetBrains Mono for numerals only. No external requests.
import "@fontsource-variable/inter/index.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@fontsource/jetbrains-mono/latin-500.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No persistent/offline cache (docs/06). Client errors are final; only network/5xx retry once.
      retry: (count, err) => !(err instanceof ApiError && err.status > 0 && err.status < 500) && count < 1,
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
